import ReleaseHistoryPage from '../pages/ReleaseHistoryPage/ReleaseHistoryPage';
import ManageReleasePage from '../pages/ManageReleasePage/ManageReleasePage.module';
import SchemaComparisonPage from '../pages/SchemaComparisionPage/SchemaComparisionPage';
import WorkflowContent from '../components/MainContainer/MiddleContent/WorkflowContent';
import TablePanel from '../components/MainContainer/MiddleContent/TablePanel';
import { FiltersPanel, ScriptPanel } from '../components/MainContainer/MiddleContent/index';
import IframePanel from '../components/MainContainer/MiddleContent/IframePanel/IframePanel';

/**
 * Maps the string keys used in JSON config files (routes, page layouts) to the
 * actual React components. JSON cannot reference components directly, so any
 * component named in a *.json config must be registered here.
 *
 * To expose a new component to config, import it and add an entry below.
 */
export const COMPONENT_REGISTRY = {
  // Route targets
  ReleaseHistoryPage,
  ManageReleasePage,
  SchemaComparisonPage,
  WorkflowContent,

  // Page-layout panels
  FiltersPanel,
  TablePanel,
  ScriptPanel,
  IframePanel,
};

/**
 * Resolve a component by its registry key. Returns null for a null/empty key
 * (used by routes that intentionally render no element), and undefined for an
 * unknown key so callers can detect misconfiguration.
 */
export function resolveComponent(key) {
  if (!key) return null;
  return COMPONENT_REGISTRY[key];
}

export default COMPONENT_REGISTRY;
